import React from "react";
import { INavLinks } from "../../../HeaderNavBar/type";
import * as styles from "./FooterNav.module.scss";
import FooterNavLink from "./FooterNavLink";
import { DropDown } from "@silversea-ssc/ui-components-react";

interface FooterNavProps {
  label: string;
  links?: INavLinks;
}

const FooterNav: React.FC<FooterNavProps> = ({ label, links }) => {
  return (
    <DropDown
      label={label}
      variant="transparent"
      expandOnMobile="inline"
      expandOnDesktop="open"
      expandOnTablet="open"
      className={styles.footerNav}
      iconClassName={styles.dropdownIcon}
      buttonClassName={styles.dropdownButton}
      contentWrapperClassName={styles.dropdownContent}
    >
      {links && (
        <ul>
          {links.map((l) => (
            <li key={l.href}>
              <FooterNavLink link={l} />
            </li>
          ))}
        </ul>
      )}
    </DropDown>
  );
};

export default FooterNav;
